module.exports = __webpack_public_path__ + "img/randomimage (3).2f9a102d.png";